import * as index from '@syncfusion/ej2-circulargauge';
index.CircularGauge.Inject( index.GaugeTooltip,index.Annotations);
export * from '@syncfusion/ej2-circulargauge';
